import { FC, memo } from 'react';
import classNames from 'classnames';

import { RadioGroup } from '@zvuk-b2b/ui-kit';

import { getDiscount } from './getDiscount';
import { getIdSlug } from './getIdSlug';
import { PricePlanPeriodListProps } from './pricePlanPeriodListProps';
import { TEXTS } from './texts';

import styles from './PricePlanPeriodList.module.scss';

const PricePlanPeriodList: FC<PricePlanPeriodListProps> = ({
  pricePlan,
  currentPeriod,
  licensesCount,
  selectedPricePlanPeriodId,
  isPrimeAvailable,
  onPricePlanPeriodChange,
}) => (
  <RadioGroup
    className={styles.pricePlanPeriodList}
    value={selectedPricePlanPeriodId}
    onValueChange={(id) => {
      const period = pricePlan?.periods.find((item) => item.id === id);

      if (period) onPricePlanPeriodChange({ period, rows: period.rows });
    }}>
    {pricePlan?.periods.map((period) => {
      if (isPrimeAvailable && period.payFrequencyMonth === 12) {
        return <></>;
      }

      const currentDiscount = getDiscount(pricePlan, period, licensesCount);
      const isCurrentPeriod = currentPeriod?.id === period.id && selectedPricePlanPeriodId !== period.id;
      const idSlug = getIdSlug(isCurrentPeriod, period.payFrequencyMonth);
      const isChecked = selectedPricePlanPeriodId === period.id;

      return (
        <RadioGroup.Item
          key={`price_plan_period_item_${idSlug}`}
          data-testid={`price_plan_period_item_${idSlug}`}
          value={period.id}
          className={classNames(styles.periodItem, {
            [styles.periodItemSelected]: isChecked,
          })}
          labelClassName={styles.discountLabel}>
          <div>{period.title}</div>
          {currentDiscount > 0 && (
            <div
              data-testid={`price_plan_period_item_${idSlug}_discount`}
              className={styles.percent}>
              {TEXTS.CHANGE_PRICE_PLAN_PERIOD_MODAL_GIFT}
            </div>
          )}
        </RadioGroup.Item>
      );
    })}
  </RadioGroup>
);

export default memo(PricePlanPeriodList);
